export const PHARMA_TEST_URL = 'totis2.webcase-dev.com'
export const HAIR_TEST_URL = 'hair.webcase-dev.com'
export const HAIR_PROD_URL = 'totis.hair'
export const PHARMA_PROD_URL = 'totispharma.com'
